(function(mod) {
    if (typeof exports == "object" && typeof module == "object") return mod(exports, require("jaydata/core")); // CommonJS
    if (typeof define == "function" && define.amd) return define(["exports", "jaydata/core"], mod); // AMD
    mod($data.generatedContext || ($data.generatedContext = {}), $data); // Plain browser env
})(function(exports, $data) {

    exports.$data = $data;

    var types = {};

    types["BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary"] = $data("$data.Entity").extend("BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        invoiceNumber: {
            "type": "Edm.String"
        },
        invoiceReferenceNumber: {
            "type": "Edm.String"
        },
        accountingTarget: {
            "type": "BookemZulu.Accounting.Domain.Models.AccountingTarget",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Accounting.Domain.Models.InvoiceType",
            "nullable": false,
            "required": true
        },
        totalNet: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        paid: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        billingDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dueDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        currencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        currencyIsoCode: {
            "type": "Edm.String"
        },
        currencyFormat: {
            "type": "Edm.String"
        },
        status: {
            "type": "BookemZulu.Accounting.Domain.Models.InvoiceStatus",
            "nullable": false,
            "required": true
        },
        clientId: {
            "type": "Edm.Int32"
        },
        clientDisplayName: {
            "type": "Edm.String"
        },
        agentId: {
            "type": "Edm.Int32"
        },
        agentName: {
            "type": "Edm.String"
        },
        supplierId: {
            "type": "Edm.Int32"
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        quoteId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quote: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "invoices"
        },
        entries: {
            "type": "Array",
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.InvoiceEntrySummary",
            "inverseProperty": "invoice"
        }
    });

    types["BookemZulu.Accounting.Logic.ViewModels.InvoiceEntrySummary"] = $data("$data.Entity").extend("BookemZulu.Accounting.Logic.ViewModels.InvoiceEntrySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        comments: {
            "type": "Edm.String"
        },
        price: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        percent: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalNet: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        invoiceId: {
            "type": "Edm.Int32"
        },
        taxId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        quoteEntryId: {
            "type": "Edm.Guid"
        },
        entryCostPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        entrySellPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        entryCostCurrencyCode: {
            "type": "Edm.String"
        },
        entrySellCurrencyCode: {
            "type": "Edm.String"
        },
        quoteId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        bookingStatus: {
            "type": "Edm.String"
        },
        bookingReference: {
            "type": "Edm.String"
        },
        confirmationReference: {
            "type": "Edm.String"
        },
        occupancy: {
            "type": "Edm.String"
        },
        clientsDisplayNames: {
            "type": "Edm.String"
        },
        productDisplayName: {
            "type": "Edm.String"
        },
        reservationDate: {
            "type": "Edm.DateTimeOffset"
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        invoice: {
            "type": "BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary",
            "nullable": false,
            "required": true,
            "inverseProperty": "entries"
        }
    });

    types["BookemZulu.Accounting.Logic.ViewModels.PaymentSummary"] = $data("$data.Entity").extend("BookemZulu.Accounting.Logic.ViewModels.PaymentSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        transactionId: {
            "type": "Edm.String"
        },
        paymentNumber: {
            "type": "Edm.String"
        },
        paymentReference: {
            "type": "Edm.String"
        },
        serviceName: {
            "type": "Edm.String"
        },
        method: {
            "type": "BookemZulu.Plugins.Core.Models.Payments.PaymentMethod",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Plugins.Core.Models.Payments.PaymentType"
        },
        status: {
            "type": "BookemZulu.Plugins.Core.Models.Payments.PaymentStatus",
            "nullable": false,
            "required": true
        },
        accountingTarget: {
            "type": "BookemZulu.Accounting.Domain.Models.AccountingTarget",
            "nullable": false,
            "required": true
        },
        paymentDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        currencyId: {
            "type": "Edm.Int32"
        },
        currencyIsoCode: {
            "type": "Edm.String"
        },
        currencyFormat: {
            "type": "Edm.String"
        },
        currencyRate: {
            "type": "Edm.Decimal"
        },
        amount: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        description: {
            "type": "Edm.String"
        },
        clientId: {
            "type": "Edm.Int32"
        },
        clientDisplayName: {
            "type": "Edm.String"
        },
        agentId: {
            "type": "Edm.Int32"
        },
        agentName: {
            "type": "Edm.String"
        },
        supplierId: {
            "type": "Edm.Int32"
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        quoteId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quote: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "payments"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.BreakdownEntry"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.BreakdownEntry", {
        id: {
            "type": "Edm.String"
        },
        quoteEntryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        quotePaxId: {
            "type": "Edm.Guid"
        },
        productDisplayName: {
            "type": "Edm.String"
        },
        clientDisplayName: {
            "type": "Edm.String"
        },
        price: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        unitPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.AgentSummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.AgentSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        canHaveCredit: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        creditNumber: {
            "type": "Edm.Decimal"
        },
        currencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        responsibleAgentId: {
            "type": "Edm.Int32"
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        managedByUserName: {
            "type": "Edm.String"
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasPolicies: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.AgentItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.AgentItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 128
        },
        canHaveCredit: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        creditNumber: {
            "type": "Edm.Decimal"
        },
        currencyId: {
            "type": "Edm.Int32"
        },
        responsibleAgentId: {
            "type": "Edm.Int32"
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        documentsLibraryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        currency: {
            "type": "BookemZulu.General.Logic.ViewModels.CurrencyItem",
            "inverseProperty": "$$unbound"
        },
        brands: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentBrandItem",
            "inverseProperty": "agent"
        },
        markets: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentMarketItem",
            "inverseProperty": "agent"
        },
        policies: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentPolicyItem",
            "inverseProperty": "agent"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.AgentBrandItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.AgentBrandItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        agentId: {
            "type": "Edm.Int32"
        },
        brandId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        brandName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        agent: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.AgentItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "brands"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.AgentPolicyItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.AgentPolicyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        priority: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        agentId: {
            "type": "Edm.Int32"
        },
        policyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        policyName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        agent: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.AgentItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "policies"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.AgentMarketItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.AgentMarketItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        agentId: {
            "type": "Edm.Int32"
        },
        marketId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marketName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        agent: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.AgentItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "markets"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.PolicySummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.PolicySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        commission: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        hasRules: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.PolicyItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.PolicyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        commission: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        rules: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem",
            "inverseProperty": "quoteProductPolicy"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuotePolicySummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuotePolicySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Bookings.Domain.Models.QuotePolicyType",
            "nullable": false,
            "required": true
        },
        productId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productDisplayName: {
            "type": "Edm.String"
        },
        hasRules: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuotePolicyItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuotePolicyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Bookings.Domain.Models.QuotePolicyType",
            "nullable": false,
            "required": true
        },
        productId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        rules: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem",
            "inverseProperty": "quotePolicy"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicySummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        margin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        priceRoundingType: {
            "type": "BookemZulu.General.Domain.Models.MarketPriceType",
            "nullable": false,
            "required": true
        },
        priority: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        hasRules: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicyItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        margin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        priceRoundingType: {
            "type": "BookemZulu.General.Domain.Models.MarketPriceType",
            "nullable": false,
            "required": true
        },
        priority: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        rules: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem",
            "inverseProperty": "sellMarginPolicy"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasRules: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        rules: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem",
            "inverseProperty": "quoteProductVisibilityPolicy"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        quoteProductPolicyId: {
            "type": "Edm.Int32"
        },
        quotePolicyId: {
            "type": "Edm.Int32"
        },
        sellMarginPolicyId: {
            "type": "Edm.Int32"
        },
        quoteProductVisibilityPolicyId: {
            "type": "Edm.Int32"
        },
        brandId: {
            "type": "Edm.Int32"
        },
        brandName: {
            "type": "Edm.String"
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType"
        },
        bookingDateFrom: {
            "type": "Edm.DateTimeOffset"
        },
        bookingDateTo: {
            "type": "Edm.DateTimeOffset"
        },
        serviceDateFrom: {
            "type": "Edm.DateTimeOffset"
        },
        serviceDateTo: {
            "type": "Edm.DateTimeOffset"
        },
        marketId: {
            "type": "Edm.Int32"
        },
        marketName: {
            "type": "Edm.String"
        },
        productCategoryId: {
            "type": "Edm.Int32"
        },
        productCategoryDisplayName: {
            "type": "Edm.String"
        },
        regionId: {
            "type": "Edm.Int32"
        },
        regionDisplayName: {
            "type": "Edm.String"
        },
        placeId: {
            "type": "Edm.Int32"
        },
        placeDisplayName: {
            "type": "Edm.String"
        },
        productId: {
            "type": "Edm.Int32"
        },
        productDisplayName: {
            "type": "Edm.String"
        },
        supplierId: {
            "type": "Edm.Int32"
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        productProviderId: {
            "type": "Edm.Int32"
        },
        productProviderName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quoteProductPolicy: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.PolicyItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "rules"
        },
        quotePolicy: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuotePolicyItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "rules"
        },
        quoteProductVisibilityPolicy: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "rules"
        },
        sellMarginPolicy: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicyItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "rules"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteSummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        quoteNumber: {
            "type": "Edm.String"
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        reservationDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        bookingDate: {
            "type": "Edm.DateTimeOffset"
        },
        confirmedDate: {
            "type": "Edm.DateTimeOffset"
        },
        status: {
            "type": "BookemZulu.Bookings.Domain.Models.QuoteStatus",
            "nullable": false,
            "required": true
        },
        totalCost: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalSale: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalSaleGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalSalesmanProfit: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        paid: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        clientId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        clientDisplayName: {
            "type": "Edm.String"
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        managedByUserName: {
            "type": "Edm.String"
        },
        parentQuoteId: {
            "type": "Edm.Int32"
        },
        travelRegionId: {
            "type": "Edm.Int32"
        },
        travelRegionCode: {
            "type": "Edm.String"
        },
        marketId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marketName: {
            "type": "Edm.String"
        },
        marketCurrencyIso3Name: {
            "type": "Edm.String"
        },
        brandId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        brandName: {
            "type": "Edm.String"
        },
        agentId: {
            "type": "Edm.Int32"
        },
        agentName: {
            "type": "Edm.String"
        },
        languageCode: {
            "type": "Edm.String"
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasPaxs: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasAgents: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasEntries: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        quoteNumber: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        managedByUserName: {
            "type": "Edm.String"
        },
        marketCurrency: {
            "type": "Edm.String"
        },
        paxCount: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        reservationDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        bookingDate: {
            "type": "Edm.DateTimeOffset"
        },
        confirmedDate: {
            "type": "Edm.DateTimeOffset"
        },
        documentsLibraryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        travelRegionId: {
            "type": "Edm.Int32"
        },
        marketId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        brandId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        languageCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        status: {
            "type": "BookemZulu.Bookings.Domain.Models.QuoteStatus",
            "nullable": false,
            "required": true
        },
        totalCost: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalSale: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalSaleGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        totalSalesmanProfit: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        paid: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        deposit: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        overrideDeposit: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        overrideInvoiceDueDate: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        invoiceDueDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        clientId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        clientDisplayName: {
            "type": "Edm.String"
        },
        parentQuoteId: {
            "type": "Edm.Int32"
        },
        agentId: {
            "type": "Edm.Int32"
        },
        agentName: {
            "type": "Edm.String"
        },
        paymentMode: {
            "type": "BookemZulu.Bookings.Domain.Models.QuotePaymentMode",
            "nullable": false,
            "required": true
        },
        defaultTaxId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        invoices: {
            "type": "Array",
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary",
            "inverseProperty": "quote"
        },
        payments: {
            "type": "Array",
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.PaymentSummary",
            "inverseProperty": "quote"
        },
        paxs: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem",
            "inverseProperty": "quote"
        },
        entries: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteEntryItem",
            "inverseProperty": "quote"
        },
        parentQuote: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "inverseProperty": "children"
        },
        children: {
            "type": "Array",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "inverseProperty": "parentQuote"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem", {
        id: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true,
            "key": true
        },
        order: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        quoteId: {
            "type": "Edm.Int32"
        },
        quoteNumber: {
            "type": "Edm.String"
        },
        clientId: {
            "type": "Edm.Int32"
        },
        clientDisplayName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quote: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "paxs"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteEntrySummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteEntrySummary", {
        id: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "key": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        status: {
            "type": "BookemZulu.Bookings.Domain.Models.QuoteEntryStatus",
            "nullable": false,
            "required": true
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        costPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        sellPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        salePriceGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        salesmanProfit: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        invoicedCost: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        calculatedCostPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        calculatedSalePriceGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        confirmationReferenceNumber: {
            "type": "Edm.String"
        },
        productId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productDisplayName: {
            "type": "Edm.String"
        },
        supplierId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        quoteId: {
            "type": "Edm.Int32"
        },
        bookingReference: {
            "type": "Edm.String"
        },
        bookingStatus: {
            "type": "Edm.String"
        },
        reservationDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        clientsDisplayNames: {
            "type": "Edm.String"
        },
        costCurrencyCode: {
            "type": "Edm.String"
        },
        sellCurrencyCode: {
            "type": "Edm.String"
        },
        sellExchangeRate: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        occupancy: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quote: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "inverseProperty": "$$unbound"
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteEntryItem"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteEntryItem", {
        id: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true,
            "key": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        order: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        isVisible: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        status: {
            "type": "BookemZulu.Bookings.Domain.Models.QuoteEntryStatus",
            "nullable": false,
            "required": true
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        costPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        sellPrice: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        salesmanProfit: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        salePriceGross: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        invoicedCost: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        paidCost: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        confirmationReferenceNumber: {
            "type": "Edm.String"
        },
        productId: {
            "type": "Edm.Int32"
        },
        productDisplayName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        supplierId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        quoteId: {
            "type": "Edm.Int32"
        },
        parentEntryId: {
            "type": "Edm.Guid"
        },
        externalId: {
            "type": "Edm.String"
        },
        externalQuoteId: {
            "type": "Edm.String"
        },
        allotmentRequestId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quote: {
            "type": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "entries"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary"] = $data("$data.Entity").extend("BookemZulu.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        quoteNumber: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        tourItineraryName: {
            "type": "Edm.String"
        },
        tourItineraryService: {
            "type": "Edm.String"
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        managedByUserName: {
            "type": "Edm.String"
        },
        tourItineraryDateId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        reservationsCount: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        documentsLibraryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Crm.Logic.ViewModels.ClientItem"] = $data("$data.Entity").extend("BookemZulu.Crm.Logic.ViewModels.ClientItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        clientNumber: {
            "type": "Edm.String"
        },
        displayName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        priority: {
            "type": "BookemZulu.Crm.Domain.Models.ClientPriority",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Crm.Domain.Models.ClientType",
            "nullable": false,
            "required": true
        },
        loginId: {
            "type": "Edm.Int32"
        },
        documentsLibraryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        status: {
            "type": "BookemZulu.Crm.Domain.Models.ClientStatus",
            "nullable": false,
            "required": true
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        languageCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Crm.Logic.ViewModels.ClientSummary"] = $data("$data.Entity").extend("BookemZulu.Crm.Logic.ViewModels.ClientSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        clientNumber: {
            "type": "Edm.String"
        },
        priority: {
            "type": "BookemZulu.Crm.Domain.Models.ClientPriority",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Crm.Domain.Models.ClientType",
            "nullable": false,
            "required": true
        },
        loginUserName: {
            "type": "Edm.String"
        },
        status: {
            "type": "BookemZulu.Crm.Domain.Models.ClientStatus",
            "nullable": false,
            "required": true
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        managedByUserName: {
            "type": "Edm.String"
        },
        languageCode: {
            "type": "Edm.String"
        },
        languageDisplayName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.GDPR.Logic.ViewModels.ClientGDPRSummary"] = $data("$data.Entity").extend("BookemZulu.GDPR.Logic.ViewModels.ClientGDPRSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        type: {
            "type": "BookemZulu.Crm.Domain.Models.ClientType",
            "nullable": false,
            "required": true
        },
        birthDate: {
            "type": "Edm.String"
        },
        email: {
            "type": "Edm.String"
        },
        contactsString: {
            "type": "Edm.String"
        },
        contacts: {
            "type": "Array",
            "elementType": "BookemZulu.Crm.Logic.JsonModels.ContactItem"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.GDPR.Logic.ViewModels.ClientGDPRItem"] = $data("$data.Entity").extend("BookemZulu.GDPR.Logic.ViewModels.ClientGDPRItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Crm.Domain.Models.ClientType",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quotes: {
            "type": "Array",
            "elementType": "BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem",
            "inverseProperty": "client"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem"] = $data("$data.Entity").extend("BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        quoteNumber: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        clientId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        travelRegionId: {
            "type": "Edm.Int32"
        },
        travelRegionCode: {
            "type": "Edm.String"
        },
        status: {
            "type": "BookemZulu.Bookings.Domain.Models.QuoteStatus",
            "nullable": false,
            "required": true
        },
        agentId: {
            "type": "Edm.Int32"
        },
        agentName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        client: {
            "type": "BookemZulu.GDPR.Logic.ViewModels.ClientGDPRItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "quotes"
        },
        paxs: {
            "type": "Array",
            "elementType": "BookemZulu.GDPR.Logic.ViewModels.QuotePaxGDPRItem",
            "inverseProperty": "quote"
        }
    });

    types["BookemZulu.GDPR.Logic.ViewModels.QuotePaxGDPRItem"] = $data("$data.Entity").extend("BookemZulu.GDPR.Logic.ViewModels.QuotePaxGDPRItem", {
        id: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true,
            "key": true
        },
        order: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        quoteId: {
            "type": "Edm.Int32"
        },
        clientId: {
            "type": "Edm.Int32"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        quote: {
            "type": "BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "paxs"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.Security.UserSummary"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.Security.UserSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userName: {
            "type": "Edm.String"
        },
        notificationEmail: {
            "type": "Edm.String"
        },
        displayName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        roles: {
            "type": "Edm.String"
        },
        isRole: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.Security.UserItem"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.Security.UserItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userName: {
            "type": "Edm.String"
        },
        notificationEmail: {
            "type": "Edm.String"
        },
        displayName: {
            "type": "Edm.String"
        },
        avatar: {
            "type": "Edm.Binary"
        },
        password: {
            "type": "Edm.String"
        },
        isRole: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.Security.RoleSummary"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.Security.RoleSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isRole: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isAdmin: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.Security.RoleItem"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.Security.RoleItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userName: {
            "type": "Edm.String"
        },
        displayName: {
            "type": "Edm.String"
        },
        isRole: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isAdmin: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.Security.UserRoleSummary"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.Security.UserRoleSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userId: {
            "type": "Edm.Int32"
        },
        roleId: {
            "type": "Edm.Int32"
        },
        displayName: {
            "type": "Edm.String"
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.Security.PermissionItem"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.Security.PermissionItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        module: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 256
        },
        name: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 64
        },
        description: {
            "type": "Edm.String",
            "maxLength": -1
        },
        parentId: {
            "type": "Edm.Int32"
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.LanguageSummary"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.LanguageSummary", {
        languageCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "key": true
        },
        flag: {
            "type": "Edm.Binary"
        },
        displayName: {
            "type": "Edm.String"
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.LanguageItem"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.LanguageItem", {
        languageCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "key": true
        },
        flag: {
            "type": "Edm.Binary"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.AutocompleteSummary"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.AutocompleteSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        concept: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 50
        },
        key: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 20
        },
        value: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": -1
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.EntitySchemaItem"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.EntitySchemaItem", {
        name: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "key": true
        },
        schema: {
            "type": "Edm.String"
        },
        isEditable: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Core.Domain.Models.EntitySchemaType",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Core.Logic.ViewModels.ConfigOptionItem"] = $data("$data.Entity").extend("BookemZulu.Core.Logic.ViewModels.ConfigOptionItem", {
        key: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "key": true
        },
        value: {
            "type": "Edm.String"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.RegionItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.RegionItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        code: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 15
        },
        codeIso2: {
            "type": "Edm.String",
            "maxLength": 15
        },
        parentRegionId: {
            "type": "Edm.Int32"
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.RegionSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.RegionSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        code: {
            "type": "Edm.String"
        },
        displayName: {
            "type": "Edm.String"
        },
        parentRegionId: {
            "type": "Edm.Int32"
        },
        location: {
            "type": "Edm.GeographyPoint"
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        codeIso2: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.PlaceSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.PlaceSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        regionId: {
            "type": "Edm.Int32"
        },
        regionName: {
            "type": "Edm.String"
        },
        parentPlaceId: {
            "type": "Edm.Int32"
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.General.Domain.Models.PlaceType",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.PlaceItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.PlaceItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        regionId: {
            "type": "Edm.Int32"
        },
        type: {
            "type": "BookemZulu.General.Domain.Models.PlaceType",
            "nullable": false,
            "required": true
        },
        location: {
            "type": "Edm.GeographyPoint"
        },
        parentPlaceId: {
            "type": "Edm.Int32"
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.AirportItem"] = types["BookemZulu.General.Logic.ViewModels.PlaceItem"].extend("BookemZulu.General.Logic.ViewModels.AirportItem", {
        code: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 3
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.AirlineSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.AirlineSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        title: {
            "type": "Edm.String"
        },
        iataCode: {
            "type": "Edm.String"
        },
        icaoCode: {
            "type": "Edm.String"
        },
        iso3Code: {
            "type": "Edm.String"
        },
        regionId: {
            "type": "Edm.Int32"
        },
        regionName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.TaxSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.TaxSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        percent: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.TaxItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.TaxItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        percent: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.AirlineItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.AirlineItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        title: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 127
        },
        iataCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 2
        },
        icaoCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 3
        },
        iso3Code: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 3
        },
        regionId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.MarketSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.MarketSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        currencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        currencyDisplayName: {
            "type": "Edm.String"
        },
        currencySymbol: {
            "type": "Edm.String"
        },
        marketPriceType: {
            "type": "BookemZulu.General.Domain.Models.MarketPriceType",
            "nullable": false,
            "required": true
        },
        defaultMargin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        depositPercent: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        invoiceDueDateInDays: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marginPolicy: {
            "type": "BookemZulu.General.Domain.Models.MarketMarginType",
            "nullable": false,
            "required": true
        },
        displayName: {
            "type": "Edm.String"
        },
        defaultTaxId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        requiresPayment: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.MarketItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.MarketItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        currencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marketPriceType: {
            "type": "BookemZulu.General.Domain.Models.MarketPriceType",
            "nullable": false,
            "required": true
        },
        defaultMargin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        depositPercent: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        invoiceDueDateInDays: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marginPolicy: {
            "type": "BookemZulu.General.Domain.Models.MarketMarginType",
            "nullable": false,
            "required": true
        },
        defaultTaxId: {
            "type": "Edm.Int32"
        },
        requiresPayment: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        defaultTax: {
            "type": "BookemZulu.General.Domain.Models.Tax",
            "inverseProperty": "$$unbound"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.CurrencySummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.CurrencySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        iso3Name: {
            "type": "Edm.String"
        },
        symbol: {
            "type": "Edm.String"
        },
        decimalPlaces: {
            "type": "Edm.Byte",
            "nullable": false,
            "required": true
        },
        format: {
            "type": "Edm.String"
        },
        isDefault: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        displayName: {
            "type": "Edm.String"
        },
        iso3NameCents: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.CurrencyItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.CurrencyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        iso3Name: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 3
        },
        iso3NameCents: {
            "type": "Edm.String",
            "maxLength": 6
        },
        symbol: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        decimalPlaces: {
            "type": "Edm.Byte",
            "nullable": false,
            "required": true
        },
        format: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        isDefault: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.BrandSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.BrandSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        description: {
            "type": "Edm.String"
        },
        prefix: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.BrandItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.BrandItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 128
        },
        logo: {
            "type": "Edm.Binary"
        },
        footer: {
            "type": "Edm.Binary"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.DocumentTemplateCategorySummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.DocumentTemplateCategorySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        type: {
            "type": "BookemZulu.Core.Domain.Models.DocumentTemplateCategoryType",
            "nullable": false,
            "required": true
        },
        usages: {
            "type": "Edm.String"
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.DocumentTemplateCategoryItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.DocumentTemplateCategoryItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        type: {
            "type": "BookemZulu.Core.Domain.Models.DocumentTemplateCategoryType",
            "nullable": false,
            "required": true
        },
        usages: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.DocumentTemplateSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.DocumentTemplateSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isDocument: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        reactComponent: {
            "type": "Edm.String"
        },
        fileName: {
            "type": "Edm.String"
        },
        documentService: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        categoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        categoryDisplayName: {
            "type": "Edm.String"
        },
        categoryUsages: {
            "type": "Edm.String"
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.DocumentTemplateItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.DocumentTemplateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        file: {
            "type": "Edm.Binary"
        },
        isDocument: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        documentService: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        categoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        category: {
            "type": "BookemZulu.General.Logic.ViewModels.DocumentTemplateCategorySummary",
            "inverseProperty": "$$unbound"
        },
        customTemplates: {
            "type": "Array",
            "elementType": "BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateItem",
            "inverseProperty": "template"
        },
        brands: {
            "type": "Array",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateBrandItem",
            "inverseProperty": "documentTemplate"
        },
        markets: {
            "type": "Array",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateMarketItem",
            "inverseProperty": "documentTemplate"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.DocumentTemplateBrandItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.DocumentTemplateBrandItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        documentTemplateId: {
            "type": "Edm.Int32"
        },
        brandId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        brandName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        documentTemplate: {
            "type": "BookemZulu.General.Logic.ViewModels.DocumentTemplateItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "brands"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.DocumentTemplateMarketItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.DocumentTemplateMarketItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        documentTemplateId: {
            "type": "Edm.Int32"
        },
        marketId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marketName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        documentTemplate: {
            "type": "BookemZulu.General.Logic.ViewModels.DocumentTemplateItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "markets"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        templateId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        userId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        userName: {
            "type": "Edm.String"
        },
        languageCode: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        file: {
            "type": "Edm.Binary",
            "nullable": false,
            "required": true
        },
        templateId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        userId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        languageCode: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        userName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        user: {
            "type": "BookemZulu.Core.Logic.ViewModels.Security.UserItem",
            "inverseProperty": "$$unbound"
        },
        language: {
            "type": "BookemZulu.Core.Logic.ViewModels.LanguageItem",
            "inverseProperty": "$$unbound"
        },
        template: {
            "type": "BookemZulu.General.Logic.ViewModels.DocumentTemplateItem",
            "inverseProperty": "customTemplates"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        categoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        categoryDisplayName: {
            "type": "Edm.String"
        },
        name: {
            "type": "Edm.String"
        },
        subject: {
            "type": "Edm.String"
        },
        body: {
            "type": "Edm.String"
        },
        target: {
            "type": "BookemZulu.General.Domain.Models.EmailDocumentTarget",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        categoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        name: {
            "type": "Edm.String"
        },
        target: {
            "type": "BookemZulu.General.Domain.Models.EmailDocumentTarget",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        category: {
            "type": "BookemZulu.General.Logic.ViewModels.DocumentTemplateCategorySummary",
            "inverseProperty": "$$unbound"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.FileSystemSummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.FileSystemSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        containerId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        filename: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 400
        },
        isLatestVersion: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isPublished: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        mimeType: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 128
        },
        permissions: {
            "type": "Edm.String"
        },
        size: {
            "type": "Edm.Int64",
            "nullable": false,
            "required": true
        },
        statusMessage: {
            "type": "Edm.String"
        },
        tags: {
            "type": "Edm.String"
        },
        title: {
            "type": "Edm.String"
        },
        version: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        ownerId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        ownerUserName: {
            "type": "Edm.String"
        },
        primaryGroupId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        primaryGroupUserName: {
            "type": "Edm.String"
        },
        secondaryGroupId: {
            "type": "Edm.Int32"
        },
        secondaryGroupUserName: {
            "type": "Edm.String"
        },
        templateId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.TaxonomyItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.TaxonomyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        jsonSchemaDefinitionName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.General.Logic.ViewModels.TaxonomySummary"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.TaxonomySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        jsonSchemaDefinitionName: {
            "type": "Edm.String"
        },
        displayName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.General.Logic.ViewModels.ApiKeyItem"] = $data("$data.Entity").extend("BookemZulu.General.Logic.ViewModels.ApiKeyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        userUserName: {
            "type": "Edm.String"
        },
        expirationDate: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductProviderItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductProviderItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        isActiveForApiAccommodation: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForApiGeneral: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForApiTransfer: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForApiFlight: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForApiCarRent: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForApiTour: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForAccommodation: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForGeneral: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForTransfer: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForFlight: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForCarRent: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isActiveForTour: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        cacheTimeForAccommodation: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        cacheTimeForGeneral: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        cacheTimeForTransfer: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        cacheTimeForFlight: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        cacheTimeForCarRent: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        cacheTimeForTour: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        canInitializeData: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        apiName: {
            "type": "Edm.String"
        },
        supplierId: {
            "type": "Edm.Int32"
        },
        supplierDefaultCurrencyIsoCode: {
            "type": "Edm.String"
        },
        requestLimits: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.EntityMappingItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.EntityMappingItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        type: {
            "type": "BookemZulu.Bookings.Domain.Models.EntityMappingType",
            "nullable": false,
            "required": true
        },
        bookemKey: {
            "type": "Edm.String"
        },
        productProviderKey: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        displayName: {
            "type": "Edm.String"
        },
        isCheckedByUser: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        productProviderId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productProviderName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.SupplierSummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.SupplierSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        title: {
            "type": "Edm.String"
        },
        supplierNumber: {
            "type": "Edm.String"
        },
        type: {
            "type": "BookemZulu.Products.Domain.Models.SupplierType",
            "nullable": false,
            "required": true
        },
        defaultCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        defaultMargin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.SupplierItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.SupplierItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        title: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 128
        },
        supplierNumber: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        documentsLibraryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        type: {
            "type": "BookemZulu.Products.Domain.Models.SupplierType",
            "nullable": false,
            "required": true
        },
        defaultCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        managedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        defaultMargin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        logo: {
            "type": "Edm.Binary"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        offices: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TransportCompanyOfficeItem",
            "inverseProperty": "supplier"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.TransportCompanyOfficeItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.TransportCompanyOfficeItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        placeId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        code: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 32
        },
        title: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 256
        },
        canPickup: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        canDropoff: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        supplierId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        supplier: {
            "type": "BookemZulu.Products.Logic.ViewModels.SupplierItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "offices"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductCategorySummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductCategorySummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        parentCategoryId: {
            "type": "Edm.Int32"
        },
        parentCategoryDisplayName: {
            "type": "Edm.String"
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        canHaveChildrenOfType: {
            "type": "BookemZulu.Core.Models.ProductType"
        },
        canHaveSupplementsOrDiscounts: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        canHaveContracts: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        taxonomicFields: {
            "type": "Array",
            "elementType": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductCategoryItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductCategoryItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        parentCategoryId: {
            "type": "Edm.Int32"
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        canHaveChildrenOfType: {
            "type": "BookemZulu.Core.Models.ProductType"
        },
        canHaveSupplementsOrDiscounts: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        canHaveContracts: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        services: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductServiceTypeItem",
            "inverseProperty": "category"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductServiceTypeItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductServiceTypeItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        categoryId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        category: {
            "type": "BookemZulu.Products.Logic.ViewModels.ProductCategoryItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "services"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductServiceTypeSummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductServiceTypeSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        categoryId: {
            "type": "Edm.Int32"
        },
        categoryDisplayName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductSummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        code: {
            "type": "Edm.String"
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        parentProductId: {
            "type": "Edm.Int32"
        },
        regionId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        regionDisplayName: {
            "type": "Edm.String"
        },
        placeId: {
            "type": "Edm.Int32"
        },
        placeDisplayName: {
            "type": "Edm.String"
        },
        categoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        categoryDisplayName: {
            "type": "Edm.String"
        },
        stopSales: {
            "type": "Edm.DateTimeOffset"
        },
        denyCurrencyConversion: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        location: {
            "type": "Edm.GeographyPoint"
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        parentDisplayName: {
            "type": "Edm.String"
        },
        isLeaf: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ProductItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ProductItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        code: {
            "type": "Edm.String",
            "maxLength": 32
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        parentProductId: {
            "type": "Edm.Int32"
        },
        regionId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        categoryId: {
            "type": "Edm.Int32"
        },
        stopSales: {
            "type": "Edm.DateTimeOffset"
        },
        denyCurrencyConversion: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        placeId: {
            "type": "Edm.Int32"
        },
        location: {
            "type": "Edm.GeographyPoint"
        },
        hasParent: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        contractsDisplayNames: {
            "type": "Array",
            "elementType": "Edm.String"
        },
        documentsLibraryId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        legacyId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        category: {
            "type": "BookemZulu.Products.Logic.ViewModels.ProductCategorySummary",
            "inverseProperty": "$$unbound"
        },
        parentProduct: {
            "type": "BookemZulu.Products.Logic.ViewModels.ProductItem",
            "inverseProperty": "childrenProducts"
        },
        childrenProducts: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductItem",
            "inverseProperty": "parentProduct"
        },
        contracts: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractItem",
            "inverseProperty": "product"
        },
        itineraries: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TourItineraryItem",
            "inverseProperty": "product"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.TourItineraryItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.TourItineraryItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        productId: {
            "type": "Edm.Int32"
        },
        productServiceTypeId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productServiceTypeDisplayName: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        product: {
            "type": "BookemZulu.Products.Logic.ViewModels.ProductItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "itineraries"
        },
        products: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TourItineraryProductItem",
            "inverseProperty": "tourItinerary"
        },
        dates: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TourItineraryDateItem",
            "inverseProperty": "tourItinerary"
        },
        contracts: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractItem",
            "inverseProperty": "tourItinerary"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.TourItineraryProductItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.TourItineraryProductItem", {
        id: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true,
            "key": true
        },
        tourItineraryId: {
            "type": "Edm.Int32"
        },
        productId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productCategoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productServiceTypeId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productServiceTypeDisplayName: {
            "type": "Edm.String"
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        productProviderId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productProviderApiName: {
            "type": "Edm.String"
        },
        productProviderName: {
            "type": "Edm.String"
        },
        supplierId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        supplierDefaultCurrencyIso3Name: {
            "type": "Edm.String"
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        isRequired: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        location: {
            "type": "Edm.GeographyPoint"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        tourItinerary: {
            "type": "BookemZulu.Products.Logic.ViewModels.TourItineraryItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "products"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.TourItineraryDateItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.TourItineraryDateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        tourItineraryId: {
            "type": "Edm.Int32"
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        isPublished: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        tourItinerary: {
            "type": "BookemZulu.Products.Logic.ViewModels.TourItineraryItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "dates"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ContractSummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ContractSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        displayName: {
            "type": "Edm.String"
        },
        productId: {
            "type": "Edm.Int32"
        },
        supplierId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ContractItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ContractItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        supplierId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        isPublished: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        productId: {
            "type": "Edm.Int32"
        },
        tourItineraryId: {
            "type": "Edm.Int32"
        },
        allotmentId: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        product: {
            "type": "BookemZulu.Products.Logic.ViewModels.ProductItem",
            "inverseProperty": "contracts"
        },
        tourItinerary: {
            "type": "BookemZulu.Products.Logic.ViewModels.TourItineraryItem",
            "inverseProperty": "contracts"
        },
        dateBands: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractRangeDateItem",
            "inverseProperty": "contract"
        },
        services: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractServiceTypeItem",
            "inverseProperty": "contract"
        },
        markets: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractMarketItem",
            "inverseProperty": "contract"
        },
        allotment: {
            "type": "BookemZulu.Products.Logic.ViewModels.AllotmentItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "contracts"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ContractMarketItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ContractMarketItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        contractId: {
            "type": "Edm.Int32"
        },
        marketId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marketName: {
            "type": "Edm.String"
        },
        marketCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        marketDefaultMargin: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        marketMarginPolicy: {
            "type": "BookemZulu.General.Domain.Models.MarketMarginType",
            "nullable": false,
            "required": true
        },
        marketMarketPriceType: {
            "type": "BookemZulu.General.Domain.Models.MarketPriceType",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        contract: {
            "type": "BookemZulu.Products.Logic.ViewModels.ContractItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "markets"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ContractRangeDateItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ContractRangeDateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        contractId: {
            "type": "Edm.Int32"
        },
        bookingDateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        bookingDateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        serviceDateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        serviceDateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        contract: {
            "type": "BookemZulu.Products.Logic.ViewModels.ContractItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "dateBands"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.ContractServiceTypeItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.ContractServiceTypeItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        contractId: {
            "type": "Edm.Int32"
        },
        productServiceTypeId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        productServiceTypeDisplayName: {
            "type": "Edm.String"
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        contract: {
            "type": "BookemZulu.Products.Logic.ViewModels.ContractItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "services"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.CurrencyDefaultRateItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.CurrencyDefaultRateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        fromCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        toCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        rate: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.CurrencyExchangeRateItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.CurrencyExchangeRateItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        fromCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        toCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        bookingDateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        bookingDateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        serviceDateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        serviceDateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        mode: {
            "type": "BookemZulu.Products.Domain.Models.CurrencyExchangeType",
            "nullable": false,
            "required": true
        },
        rate: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.AllotmentSummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.AllotmentSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        parentAllotmentId: {
            "type": "Edm.Int32"
        },
        productDisplayName: {
            "type": "Edm.String"
        },
        supplierTitle: {
            "type": "Edm.String"
        },
        byDefault: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasChildren: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        hasContracts: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.AllotmentItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.AllotmentItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        parentAllotmentId: {
            "type": "Edm.Int32"
        },
        productId: {
            "type": "Edm.Int32"
        },
        productType: {
            "type": "BookemZulu.Core.Models.ProductType",
            "nullable": false,
            "required": true
        },
        categoryId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        supplierId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        byDefault: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        product: {
            "type": "BookemZulu.Products.Logic.ViewModels.ProductItem",
            "inverseProperty": "$$unbound"
        },
        parentAllotment: {
            "type": "BookemZulu.Products.Logic.ViewModels.AllotmentItem",
            "inverseProperty": "childrenAllotment"
        },
        childrenAllotment: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentItem",
            "inverseProperty": "parentAllotment"
        },
        contracts: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractItem",
            "inverseProperty": "allotment"
        },
        allotmentRanges: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem",
            "inverseProperty": "allotment"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeSummary"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.AllotmentRangeSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        allotmentId: {
            "type": "Edm.Int32"
        },
        allotmentRangeType: {
            "type": "BookemZulu.Products.Domain.Models.AllotmentRangeType",
            "nullable": false,
            "required": true
        },
        totalLimit: {
            "type": "Edm.Int32"
        },
        dailyLimit: {
            "type": "Edm.Int32"
        },
        description: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        dateFrom: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dateTo: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        allotmentId: {
            "type": "Edm.Int32"
        },
        allotmentRangeType: {
            "type": "BookemZulu.Products.Domain.Models.AllotmentRangeType",
            "nullable": false,
            "required": true
        },
        totalLimit: {
            "type": "Edm.Int32"
        },
        dailyLimit: {
            "type": "Edm.Int32"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        allotment: {
            "type": "BookemZulu.Products.Logic.ViewModels.AllotmentItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "allotmentRanges"
        },
        allotmentRangeDailies: {
            "type": "Array",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentRangeDailyItem",
            "inverseProperty": "allotmentRange"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeDailyItem"] = $data("$data.Entity").extend("BookemZulu.Products.Logic.ViewModels.AllotmentRangeDailyItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        allotmentRangeId: {
            "type": "Edm.Int32"
        },
        day: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        date: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        dailyLimit: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        allotmentRange: {
            "type": "BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem",
            "nullable": false,
            "required": true,
            "inverseProperty": "allotmentRangeDailies"
        }
    });

    types["BookemZulu.General.Domain.Services.TaxonomicField"] = $data("$data.Entity").extend("BookemZulu.General.Domain.Services.TaxonomicField", {
        displayName: {
            "type": "Edm.String"
        },
        jsonSchemaPropertyName: {
            "type": "Edm.String"
        },
        jsonSchemaDefinitionName: {
            "type": "Edm.String"
        }
    });

    types["BookemZulu.Plugins.Core.Services.ExchangeRateResult"] = $data("$data.Entity").extend("BookemZulu.Plugins.Core.Services.ExchangeRateResult", {
        rate: {
            "type": "Edm.Double",
            "nullable": false,
            "required": true
        },
        amount: {
            "type": "Edm.Double",
            "nullable": false,
            "required": true
        },
        fromCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        toCurrencyId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        }
    });

    types["BookemZulu.Products.Domain.Services.AvailabilityAllotmentItem"] = $data("$data.Entity").extend("BookemZulu.Products.Domain.Services.AvailabilityAllotmentItem", {
        date: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        description: {
            "type": "Edm.String"
        },
        limit: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        allotmentRangeId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        allotmentRangeDailyId: {
            "type": "Edm.Int32"
        },
        allotmentRangeType: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        occupied: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        }
    });

    types["BookemZulu.Rules.Logic.ViewModels.RuleItem"] = $data("$data.Entity").extend("BookemZulu.Rules.Logic.ViewModels.RuleItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 255
        },
        eventTypeFullName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 255
        },
        eventName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 255
        },
        eventWrapperName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        description: {
            "type": "Edm.String"
        },
        eventDescription: {
            "type": "Edm.String"
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        mode: {
            "type": "BookemZulu.Rules.Domain.Models.Rules.RuleExecutionMode",
            "nullable": false,
            "required": true
        },
        executionDeadline: {
            "type": "Edm.DateTimeOffset"
        },
        executionTimeSpan: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Rules.Logic.ViewModels.RuleSummary"] = $data("$data.Entity").extend("BookemZulu.Rules.Logic.ViewModels.RuleSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        name: {
            "type": "Edm.String"
        },
        eventTypeFullName: {
            "type": "Edm.String"
        },
        eventName: {
            "type": "Edm.String"
        },
        isActive: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        description: {
            "type": "Edm.String"
        },
        eventDescription: {
            "type": "Edm.String"
        },
        lastExecutionMessage: {
            "type": "Edm.String"
        },
        lastExecutionTime: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        mode: {
            "type": "BookemZulu.Rules.Domain.Models.Rules.RuleExecutionMode",
            "nullable": false,
            "required": true
        },
        executionDeadline: {
            "type": "Edm.DateTimeOffset"
        },
        executionTimeSpan: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    });

    types["BookemZulu.Rules.Logic.ViewModels.UserTaskItem"] = $data("$data.Entity").extend("BookemZulu.Rules.Logic.ViewModels.UserTaskItem", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        title: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 255
        },
        body: {
            "type": "Edm.String"
        },
        priority: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        daedline: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        state: {
            "type": "BookemZulu.Rules.Domain.Models.UserTasks.TaskState",
            "nullable": false,
            "required": true
        },
        assignedToId: {
            "type": "Edm.Int32"
        },
        modelType: {
            "type": "Edm.String"
        },
        modelId: {
            "type": "Edm.String"
        },
        changeReason: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary",
            "concurrencyMode": $data.ConcurrencyMode.Fixed
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        },
        assignedTo: {
            "type": "BookemZulu.Core.Domain.Models.User",
            "inverseProperty": "$$unbound"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Rules.Logic.ViewModels.UserTaskSummary"] = $data("$data.Entity").extend("BookemZulu.Rules.Logic.ViewModels.UserTaskSummary", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        title: {
            "type": "Edm.String"
        },
        body: {
            "type": "Edm.String"
        },
        priority: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        daedline: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        state: {
            "type": "BookemZulu.Rules.Domain.Models.UserTasks.TaskState",
            "nullable": false,
            "required": true
        },
        assignedToUserName: {
            "type": "Edm.String"
        },
        assignedToId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modelType: {
            "type": "Edm.String"
        },
        modelId: {
            "type": "Edm.String"
        },
        uniqueId: {
            "type": "Edm.Guid"
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        createdById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        createdByUserName: {
            "type": "Edm.String"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset"
        },
        modifiedById: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        modifiedByUserName: {
            "type": "Edm.String"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset"
        }
    }, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Product"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Product", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ExtraProperties"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ExtraProperties", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Parent"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Parent", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Service"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Service", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.CostPriceResult"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.CostPriceResult", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.SellPriceResult"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.SellPriceResult", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Breakdown"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Breakdown", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.History"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.History", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.CostCommission"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.CostCommission", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.SellCommission"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.SellCommission", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Drivers"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Drivers", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Features"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Features", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ErratasConfirmed"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ErratasConfirmed", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.AllotmentAvailable"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.AllotmentAvailable", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Occupancy"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Occupancy", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.IsPackage"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.IsPackage", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Itinerary"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Itinerary", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.DepartureAirport"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.DepartureAirport", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.DestinationAirport"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.DestinationAirport", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Category"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Category", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Segments"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Segments", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Stops"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Stops", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.FlightLegs"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.FlightLegs", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ExternalIds"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ExternalIds", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ClientExternalIds"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ClientExternalIds", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.IsATOL"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.IsATOL", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Person"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Person", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Company"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Company", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Phones"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Phones", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Emails"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Emails", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Contact"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Contact", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Note"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Note", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Children"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Children", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.DisplayName"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.DisplayName", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Translations"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Translations", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Datasets"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Datasets", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.TaxonomyTags"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.TaxonomyTags", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Html"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Html", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Subject"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Subject", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ReceiveTaskNotifications"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ReceiveTaskNotifications", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.AgeBands"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.AgeBands", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.CustomOccupancyConfigs"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.CustomOccupancyConfigs", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Cost"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Cost", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Price"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Price", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Structure"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Structure", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Accomodation"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Accomodation", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Transfer"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Transfer", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Flight"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Flight", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Elements"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Elements", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Content"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Content", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.OpeningHour"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.OpeningHour", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ClosingHour"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ClosingHour", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.CanDropoff"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.CanDropoff", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Observations"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Observations", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.OtherPaxsConfig"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.OtherPaxsConfig", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Erratas"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Erratas", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Visibility"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Visibility", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.PaxConfig"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.PaxConfig", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Occupancies"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Occupancies", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.MarketsPrice"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.MarketsPrice", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Products"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Products", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.OccupanciesPrice"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.OccupanciesPrice", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ConditionValues"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ConditionValues", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Conditions"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Conditions", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.BranchExecutors"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.BranchExecutors", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.AlternativeExecutors"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.AlternativeExecutors", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Policy"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Policy", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Name"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Name", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ConditionDefinitionType"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ConditionDefinitionType", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.LastState"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.LastState", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.LastExecutionMessage"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.LastExecutionMessage", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.RetryCount"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.RetryCount", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.MaxRetryInterval"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.MaxRetryInterval", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.MinRetryInterval"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.MinRetryInterval", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.HistoryLogs"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.HistoryLogs", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Logs"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Logs", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.Changes"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.Changes", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.ChangeReason"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.ChangeReason", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.OpenTypes.UserTaskModifiedBy"] = $data("$data.Entity").extend("BookemZulu.OpenTypes.UserTaskModifiedBy", null, {
        openType: {
            "value": true
        }
    });

    types["BookemZulu.Crm.Logic.JsonModels.ContactItem"] = $data("$data.Entity").extend("BookemZulu.Crm.Logic.JsonModels.ContactItem", {
        displayName: {
            "type": "Edm.String"
        },
        postalCode: {
            "type": "Edm.String"
        },
        regionId: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true
        },
        city: {
            "type": "Edm.String"
        },
        county: {
            "type": "Edm.String"
        },
        address: {
            "type": "Edm.String"
        },
        additionalAddress: {
            "type": "Edm.String"
        },
        phones: {
            "type": "Array",
            "elementType": "BookemZulu.Crm.Logic.JsonModels.PhoneItem"
        },
        emails: {
            "type": "Array",
            "elementType": "BookemZulu.Crm.Logic.JsonModels.EmailItem"
        }
    });

    types["BookemZulu.Crm.Logic.JsonModels.PhoneItem"] = $data("$data.Entity").extend("BookemZulu.Crm.Logic.JsonModels.PhoneItem", {
        type: {
            "type": "Edm.String"
        },
        number: {
            "type": "Edm.String"
        }
    });

    types["BookemZulu.Crm.Logic.JsonModels.EmailItem"] = $data("$data.Entity").extend("BookemZulu.Crm.Logic.JsonModels.EmailItem", {
        type: {
            "type": "Edm.String"
        },
        email: {
            "type": "Edm.String"
        }
    });

    types["BookemZulu.General.Domain.Models.MarketPriceType"] = $data.createEnum("BookemZulu.General.Domain.Models.MarketPriceType", [{
            "name": "RoundUp",
            "index": 0,
            "value": 0
        },
        {
            "name": "RoundDown",
            "index": 1,
            "value": 1
        },
        {
            "name": "Truncate",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.General.Domain.Models.PlaceType"] = $data.createEnum("BookemZulu.General.Domain.Models.PlaceType", [{
            "name": "General",
            "index": 0,
            "value": 0
        },
        {
            "name": "Airport",
            "index": 1,
            "value": 1
        },
        {
            "name": "Resort",
            "index": 2,
            "value": 2
        },
        {
            "name": "TransferPoint",
            "index": 3,
            "value": 3
        },
        {
            "name": "CoachPickupPoint",
            "index": 4,
            "value": 4
        }
    ]);

    types["BookemZulu.General.Domain.Models.MarketMarginType"] = $data.createEnum("BookemZulu.General.Domain.Models.MarketMarginType", [{
            "name": "MarketMargin",
            "index": 0,
            "value": 0
        },
        {
            "name": "SupplierMargin",
            "index": 1,
            "value": 1
        },
        {
            "name": "MarketAndSupplierMargin",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.General.Domain.Models.EmailDocumentTarget"] = $data.createEnum("BookemZulu.General.Domain.Models.EmailDocumentTarget", [{
            "name": "Agents",
            "index": 0,
            "value": 0
        },
        {
            "name": "Clients",
            "index": 1,
            "value": 1
        },
        {
            "name": "Suppliers",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.General.Domain.Models.Tax"] = $data("$data.Entity").extend("BookemZulu.General.Domain.Models.Tax", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        percent: {
            "type": "Edm.Decimal",
            "nullable": false,
            "required": true
        },
        dynamicProperties: {
            "type": "Edm.String",
            "maxLength": -1
        },
        uniqueId: {
            "type": "Edm.Guid",
            "nullable": false,
            "required": true
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary"
        },
        createdById: {
            "type": "Edm.Int32"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        modifiedById: {
            "type": "Edm.Int32"
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        createdBy: {
            "type": "BookemZulu.Core.Domain.Models.User",
            "inverseProperty": "$$unbound"
        },
        modifiedBy: {
            "type": "BookemZulu.Core.Domain.Models.User",
            "inverseProperty": "$$unbound"
        }
    });

    types["BookemZulu.Core.Domain.Models.EntitySchemaType"] = $data.createEnum("BookemZulu.Core.Domain.Models.EntitySchemaType", [{
            "name": "TableEntity",
            "index": 0,
            "value": 0
        },
        {
            "name": "JsonEntity",
            "index": 1,
            "value": 1
        },
        {
            "name": "Taxonomy",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.Core.Domain.Models.DocumentTemplateCategoryType"] = $data.createEnum("BookemZulu.Core.Domain.Models.DocumentTemplateCategoryType", [{
            "name": "General",
            "index": 0,
            "value": 0
        },
        {
            "name": "Invoice",
            "index": 1,
            "value": 1
        },
        {
            "name": "Offer",
            "index": 2,
            "value": 2
        },
        {
            "name": "Voucher",
            "index": 3,
            "value": 3
        },
        {
            "name": "Report",
            "index": 4,
            "value": 4
        }
    ]);

    types["BookemZulu.Core.Domain.Models.User"] = $data("$data.Entity").extend("BookemZulu.Core.Domain.Models.User", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true
        },
        notificationEmail: {
            "type": "Edm.String",
            "maxLength": 255
        },
        displayName: {
            "type": "Edm.String",
            "nullable": false,
            "required": true,
            "maxLength": 255
        },
        isDeleted: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        timestamp: {
            "type": "Edm.Binary"
        },
        createdOn: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        modifiedOn: {
            "type": "Edm.DateTimeOffset",
            "nullable": false,
            "required": true
        },
        avatar: {
            "type": "Edm.Binary"
        },
        password: {
            "type": "Edm.String"
        },
        dynamicProperties: {
            "type": "Edm.String"
        },
        isRole: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        isAdmin: {
            "type": "Edm.Boolean",
            "nullable": false,
            "required": true
        },
        roles: {
            "type": "Array",
            "elementType": "BookemZulu.Core.Domain.Models.UserRole",
            "inverseProperty": "$$unbound"
        },
        users: {
            "type": "Array",
            "elementType": "BookemZulu.Core.Domain.Models.UserRole",
            "inverseProperty": "$$unbound"
        }
    });

    types["BookemZulu.Core.Domain.Models.UserRole"] = $data("$data.Entity").extend("BookemZulu.Core.Domain.Models.UserRole", {
        id: {
            "type": "Edm.Int32",
            "nullable": false,
            "required": true,
            "key": true
        },
        userId: {
            "type": "Edm.Int32"
        },
        roleId: {
            "type": "Edm.Int32"
        },
        user: {
            "type": "BookemZulu.Core.Domain.Models.User",
            "inverseProperty": "$$unbound"
        },
        role: {
            "type": "BookemZulu.Core.Domain.Models.User",
            "inverseProperty": "$$unbound"
        }
    });

    types["BookemZulu.Bookings.Domain.Models.QuoteEntryStatus"] = $data.createEnum("BookemZulu.Bookings.Domain.Models.QuoteEntryStatus", [{
            "name": "Draft",
            "index": 0,
            "value": 0
        },
        {
            "name": "Pending",
            "index": 1,
            "value": 1
        },
        {
            "name": "Processing",
            "index": 2,
            "value": 2
        },
        {
            "name": "Confirmed",
            "index": 3,
            "value": 3
        },
        {
            "name": "CancelledByClient",
            "index": 4,
            "value": 4
        },
        {
            "name": "DeniedBySupplier",
            "index": 5,
            "value": 5
        },
        {
            "name": "CancelledBySupplier",
            "index": 6,
            "value": 6
        }
    ]);

    types["BookemZulu.Bookings.Domain.Models.QuotePolicyType"] = $data.createEnum("BookemZulu.Bookings.Domain.Models.QuotePolicyType", [{
            "name": "General",
            "index": 0,
            "value": 0
        },
        {
            "name": "Product",
            "index": 1,
            "value": 1
        }
    ]);

    types["BookemZulu.Bookings.Domain.Models.QuoteStatus"] = $data.createEnum("BookemZulu.Bookings.Domain.Models.QuoteStatus", [{
            "name": "Draft",
            "index": 0,
            "value": 0
        },
        {
            "name": "Open",
            "index": 1,
            "value": 1
        },
        {
            "name": "Confirmed",
            "index": 2,
            "value": 2
        },
        {
            "name": "Closed",
            "index": 3,
            "value": 3
        },
        {
            "name": "Cancelled",
            "index": 4,
            "value": 4
        }
    ]);

    types["BookemZulu.Bookings.Domain.Models.QuotePaymentMode"] = $data.createEnum("BookemZulu.Bookings.Domain.Models.QuotePaymentMode", [{
            "name": "Direct",
            "index": 0,
            "value": 0
        },
        {
            "name": "Indirect",
            "index": 1,
            "value": 1
        }
    ]);

    types["BookemZulu.Bookings.Domain.Models.EntityMappingType"] = $data.createEnum("BookemZulu.Bookings.Domain.Models.EntityMappingType", [{
            "name": "Region",
            "index": 0,
            "value": 0
        },
        {
            "name": "Place",
            "index": 1,
            "value": 1
        },
        {
            "name": "Product",
            "index": 2,
            "value": 2
        },
        {
            "name": "Supplier",
            "index": 3,
            "value": 3
        },
        {
            "name": "Airline",
            "index": 4,
            "value": 4
        }
    ]);

    types["BookemZulu.Accounting.Domain.Models.AccountingTarget"] = $data.createEnum("BookemZulu.Accounting.Domain.Models.AccountingTarget", [{
            "name": "Client",
            "index": 0,
            "value": 1
        },
        {
            "name": "Agent",
            "index": 1,
            "value": 2
        },
        {
            "name": "Supplier",
            "index": 2,
            "value": 4
        }
    ]);

    types["BookemZulu.Accounting.Domain.Models.InvoiceType"] = $data.createEnum("BookemZulu.Accounting.Domain.Models.InvoiceType", [{
            "name": "Invoice",
            "index": 0,
            "value": 0
        },
        {
            "name": "CreditNote",
            "index": 1,
            "value": 1
        },
        {
            "name": "DebitNote",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.Accounting.Domain.Models.InvoiceStatus"] = $data.createEnum("BookemZulu.Accounting.Domain.Models.InvoiceStatus", [{
            "name": "Draft",
            "index": 0,
            "value": 0
        },
        {
            "name": "Accounted",
            "index": 1,
            "value": 1
        },
        {
            "name": "Paid",
            "index": 2,
            "value": 2
        },
        {
            "name": "Cancelled",
            "index": 3,
            "value": 3
        }
    ]);

    types["BookemZulu.Plugins.Core.Models.Payments.PaymentMethod"] = $data.createEnum("BookemZulu.Plugins.Core.Models.Payments.PaymentMethod", [{
            "name": "Cash",
            "index": 0,
            "value": 0
        },
        {
            "name": "BankTransfer",
            "index": 1,
            "value": 1
        },
        {
            "name": "Card",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.Plugins.Core.Models.Payments.PaymentType"] = $data.createEnum("BookemZulu.Plugins.Core.Models.Payments.PaymentType", [{
            "name": "Payment",
            "index": 0,
            "value": 0
        },
        {
			"name": "Refund",
            "index": 1,
            "value": 1
        },
        {
            "name": "Deferred",
            "index": 2,
            "value": 2
        },
        {
            "name": "Cancelled",
            "index": 3,
            "value": 4
        }
    ]);

    types["BookemZulu.Plugins.Core.Models.Payments.PaymentStatus"] = $data.createEnum("BookemZulu.Plugins.Core.Models.Payments.PaymentStatus", [{
            "name": "Draft",
            "index": 0,
            "value": 0
        },
        {
            "name": "Pending",
            "index": 1,
            "value": 1
        },
        {
            "name": "Finished",
            "index": 2,
            "value": 2
        },
        {
            "name": "Failed",
            "index": 3,
            "value": 3
        },
        {
            "name": "Processing",
            "index": 4,
            "value": 4
        },
        {
            "name": "Cancelled",
            "index": 5,
            "value": 5
        },
        {
            "name": "Refunded",
            "index": 6,
            "value": 6
        }
    ]);

    types["BookemZulu.Core.Models.ProductType"] = $data.createEnum("BookemZulu.Core.Models.ProductType", [{
            "name": "General",
            "index": 0,
            "value": 0
        },
        {
            "name": "Accommodation",
            "index": 1,
            "value": 1
        },
        {
            "name": "CarRent",
            "index": 2,
            "value": 2
        },
        {
            "name": "Transfer",
            "index": 3,
            "value": 3
        },
        {
            "name": "Flight",
            "index": 4,
            "value": 4
        },
        {
            "name": "Room",
            "index": 5,
            "value": 5
        },
        {
            "name": "SupplementDiscount",
            "index": 6,
            "value": 6
        },
        {
            "name": "SalesAdjustment",
            "index": 7,
            "value": 7
        },
        {
            "name": "AccountingAdjustment",
            "index": 8,
            "value": 8
        },
        {
            "name": "Tour",
            "index": 9,
            "value": 9
        },
        {
            "name": "Package",
            "index": 10,
            "value": 10
        }
    ]);

    types["BookemZulu.Crm.Domain.Models.ClientPriority"] = $data.createEnum("BookemZulu.Crm.Domain.Models.ClientPriority", [{
            "name": "Low",
            "index": 0,
            "value": 0
        },
        {
            "name": "Medium",
            "index": 1,
            "value": 1
        },
        {
            "name": "Normal",
            "index": 2,
            "value": 2
        },
        {
            "name": "High",
            "index": 3,
            "value": 3
        },
        {
            "name": "Super",
            "index": 4,
            "value": 4
        },
        {
            "name": "Vip",
            "index": 5,
            "value": 5
        }
    ]);

    types["BookemZulu.Crm.Domain.Models.ClientType"] = $data.createEnum("BookemZulu.Crm.Domain.Models.ClientType", [{
            "name": "Person",
            "index": 0,
            "value": 0
        },
        {
            "name": "Group",
            "index": 1,
            "value": 1
        },
        {
            "name": "Company",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.Crm.Domain.Models.ClientStatus"] = $data.createEnum("BookemZulu.Crm.Domain.Models.ClientStatus", [{
            "name": "Client",
            "index": 0,
            "value": 0
        },
        {
            "name": "WillBook",
            "index": 1,
            "value": 1
        },
        {
            "name": "Interested",
            "index": 2,
            "value": 2
        },
        {
            "name": "OnlyInformationRequest",
            "index": 3,
            "value": 3
        },
        {
            "name": "NotInterested",
            "index": 4,
            "value": 4
        },
        {
            "name": "NoMoreContact",
            "index": 5,
            "value": 5
        },
        {
            "name": "CoTraveler",
            "index": 6,
            "value": 6
        }
    ]);

    types["BookemZulu.Products.Domain.Models.SupplierType"] = $data.createEnum("BookemZulu.Products.Domain.Models.SupplierType", [{
            "name": "General",
            "index": 0,
            "value": 0
        },
        {
            "name": "CarRent",
            "index": 1,
            "value": 1
        }
    ]);

    types["BookemZulu.Products.Domain.Models.CurrencyExchangeType"] = $data.createEnum("BookemZulu.Products.Domain.Models.CurrencyExchangeType", [{
            "name": "Hedge",
            "index": 0,
            "value": 0
        },
        {
            "name": "Real",
            "index": 1,
            "value": 1
        },
        {
            "name": "Payment",
            "index": 2,
            "value": 2
        },
        {
            "name": "Default",
            "index": 3,
            "value": 3
        }
    ]);

    types["BookemZulu.Products.Domain.Models.AllotmentRangeType"] = $data.createEnum("BookemZulu.Products.Domain.Models.AllotmentRangeType", [{
            "name": "Stopsale",
            "index": 0,
            "value": 0
        },
        {
            "name": "Byavailability",
            "index": 1,
            "value": 1
        },
        {
            "name": "Byrequest",
            "index": 2,
            "value": 2
        },
        {
            "name": "Unavailable",
            "index": 3,
            "value": 3
        },
        {
            "name": "Freesell",
            "index": 4,
            "value": 4
        }
    ]);

    types["BookemZulu.Rules.Domain.Models.Rules.RuleExecutionMode"] = $data.createEnum("BookemZulu.Rules.Domain.Models.Rules.RuleExecutionMode", [{
            "name": "OnEntityChange",
            "index": 0,
            "value": 0
        },
        {
            "name": "Scheduled",
            "index": 1,
            "value": 1
        },
        {
            "name": "Recurrent",
            "index": 2,
            "value": 2
        }
    ]);

    types["BookemZulu.Rules.Domain.Models.UserTasks.TaskState"] = $data.createEnum("BookemZulu.Rules.Domain.Models.UserTasks.TaskState", [{
            "name": "New",
            "index": 0,
            "value": 0
        },
        {
            "name": "InProgress",
            "index": 1,
            "value": 1
        },
        {
            "name": "Finished",
            "index": 2,
            "value": 2
        },
        {
            "name": "Cancelled",
            "index": 3,
            "value": 4
        },
        {
            "name": "OutOfDate",
            "index": 4,
            "value": 8
        }
    ]);

    exports.type = types["OData.Container"] = $data("$data.EntityContext").extend("OData.Container", {
        InvoiceSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary"
        },
        InvoiceEntrySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.InvoiceEntrySummary"
        },
        PaymentSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.PaymentSummary"
        },
        AgentSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentSummary"
        },
        Agents: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentItem"
        },
        AgentBrands: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentBrandItem"
        },
        AgentPolicies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentPolicyItem"
        },
        AgentMarkets: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.AgentMarketItem"
        },
        PolicySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicySummary"
        },
        Policies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicyItem"
        },
        QuotePolicySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuotePolicySummary"
        },
        QuotePolicies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuotePolicyItem"
        },
        SellMarginPolicySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicySummary"
        },
        SellMarginPolicies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicyItem"
        },
        QuoteProductVisibilityPolicySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary"
        },
        QuoteProductVisibilityPolicies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem"
        },
        PolicyRules: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem"
        },
        QuoteSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteSummary"
        },
        Quotes: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem"
        },
        QuotePaxs: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem"
        },
        QuoteEntrySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteEntrySummary"
        },
        QuoteEntries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteEntryItem"
        },
        QuoteItineraryGroupSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary"
        },
        Clients: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Crm.Logic.ViewModels.ClientItem"
        },
        ClientsSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Crm.Logic.ViewModels.ClientSummary"
        },
        ClientsGDPRSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.GDPR.Logic.ViewModels.ClientGDPRSummary"
        },
        ClientsGDPR: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.GDPR.Logic.ViewModels.ClientGDPRItem"
        },
        QuotesGDPR: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem"
        },
        QuotePaxsGDPR: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.GDPR.Logic.ViewModels.QuotePaxGDPRItem"
        },
        UsersSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.Security.UserSummary"
        },
        Users: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.Security.UserItem"
        },
        RolesSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.Security.RoleSummary"
        },
        Roles: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.Security.RoleItem"
        },
        UserRoleSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.Security.UserRoleSummary"
        },
        Permissions: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.Security.PermissionItem"
        },
        LanguagesSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.LanguageSummary"
        },
        Languages: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.LanguageItem"
        },
        AutocompleteSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.AutocompleteSummary"
        },
        Regions: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.RegionItem"
        },
        RegionsSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.RegionSummary"
        },
        PlacesSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.PlaceSummary"
        },
        Places: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.PlaceItem"
        },
        Airports: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.AirportItem"
        },
        AirlinesSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.AirlineSummary"
        },
        TaxsSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.TaxSummary"
        },
        Taxs: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.TaxItem"
        },
        EntitySchemas: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.EntitySchemaItem"
        },
        Airlines: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.AirlineItem"
        },
        ConfigOptions: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Core.Logic.ViewModels.ConfigOptionItem"
        },
        MarketSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.MarketSummary"
        },
        Markets: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.MarketItem"
        },
        CurrencySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.CurrencySummary"
        },
        Currencies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.CurrencyItem"
        },
        BrandSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.BrandSummary"
        },
        Brands: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.BrandItem"
        },
        DocumentTemplateCategorySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateCategorySummary"
        },
        DocumentTemplateCategories: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateCategoryItem"
        },
        DocumentTemplateSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateSummary"
        },
        DocumentTemplates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateItem"
        },
        DocumentTemplateBrands: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateBrandItem"
        },
        DocumentTemplateMarkets: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.DocumentTemplateMarketItem"
        },
        CustomDocumentTemplateSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateSummary"
        },
        CustomDocumentTemplates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateItem"
        },
        EmailDocumentTemplateSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateSummary"
        },
        EmailDocumentTemplates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateItem"
        },
        FileSystemSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.FileSystemSummary"
        },
        Taxonomies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.TaxonomyItem"
        },
        TaxonomySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.TaxonomySummary"
        },
        ApiKeys: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.General.Logic.ViewModels.ApiKeyItem"
        },
        ProductProviders: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductProviderItem"
        },
        EntityMappings: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.EntityMappingItem"
        },
        SupplierSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.SupplierSummary"
        },
        Suppliers: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.SupplierItem"
        },
        TransportCompanyOffices: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TransportCompanyOfficeItem"
        },
        ProductCategorySummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductCategorySummary"
        },
        ProductCategories: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductCategoryItem"
        },
        ProductServiceTypes: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductServiceTypeItem"
        },
        ProductServiceTypeSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductServiceTypeSummary"
        },
        ProductSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductSummary"
        },
        Products: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ProductItem"
        },
        TourItineraries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TourItineraryItem"
        },
        TourItineraryProducts: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TourItineraryProductItem"
        },
        TourItineraryDates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.TourItineraryDateItem"
        },
        ContractSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractSummary"
        },
        Contracts: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractItem"
        },
        ContractMarkets: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractMarketItem"
        },
        ContractRangeDates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractRangeDateItem"
        },
        ContractServiceTypes: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.ContractServiceTypeItem"
        },
        CurrencyDefaultRates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.CurrencyDefaultRateItem"
        },
        CurrencyExchangeRates: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.CurrencyExchangeRateItem"
        },
        AllotmentSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentSummary"
        },
        Allotments: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentItem"
        },
        AllotmentRangeSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentRangeSummary"
        },
        AllotmentRanges: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem"
        },
        AllotmentRangeDailies: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Products.Logic.ViewModels.AllotmentRangeDailyItem"
        },
        Rules: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Rules.Logic.ViewModels.RuleItem"
        },
        RuleSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Rules.Logic.ViewModels.RuleSummary"
        },
        UserTasks: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Rules.Logic.ViewModels.UserTaskItem"
        },
        UserTaskSummaries: {
            "type": "$data.EntitySet",
            "elementType": "BookemZulu.Rules.Logic.ViewModels.UserTaskSummary"
        },
        GenerateInvoices: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "QuoteEntryId",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary"
        },
        GetPaymentInvoices: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "PaymentId",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary"
        },
        QuoteChangeStatus: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Boolean",
            "params": [{
                "name": "QuoteId",
                "type": "Edm.Int32"
            }, {
                "name": "Cancel",
                "type": "Edm.Boolean"
            }]
        },
        InitializeData: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Boolean",
            "params": [{
                "name": "ProductProviderApiName",
                "type": "Edm.String"
            }]
        },
        QuoteEntryChangeStatus: {
			"type": "$data.ServiceFunction",
			"returnType": "Edm.Int32",
            "params": [{
                "name": "QuoteEntryId",
                "type": "Edm.Guid"
            }, {
                "name": "Observations",
                "type": "Edm.String"
            }, {
                "name": "ConfirmationNumber",
                "type": "Edm.String"
            }, {
                "name": "RejectedAs",
                "type": "BookemZulu.Bookings.Domain.Models.QuoteEntryStatus"
            }]
        },
        GetBreakdown: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "QuoteEntryId",
                "type": "Edm.Guid"
            }],
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.BreakdownEntry"
        },
        Availability: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Int32",
            "params": [{
                "name": "idAllotment",
                "type": "Edm.Int32"
            }, {
                "name": "Date",
                "type": "Edm.DateTimeOffset"
            }]
        },
        Block: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Int32",
            "params": [{
                "name": "allotmentId",
                "type": "Edm.Int32"
            }, {
                "name": "DateFrom",
                "type": "Edm.DateTimeOffset"
            }, {
                "name": "DateTo",
                "type": "Edm.DateTimeOffset"
            }, {
                "name": "Qty",
                "type": "Edm.Int32"
            }, {
                "name": "expirationDate",
                "type": "Edm.DateTimeOffset"
            }]
        },
        Booking: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Int32",
            "params": [{
                "name": "DateFrom",
                "type": "Edm.DateTimeOffset"
            }, {
                "name": "DateTo",
                "type": "Edm.DateTimeOffset"
            }, {
                "name": "Qty",
                "type": "Edm.Int32"
            }, {
                "name": "idAllotment",
                "type": "Edm.Int32"
            }, {
                "name": "idAllotmentRequest",
                "type": "Edm.Int32"
            }]
        },
        Occupied: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Int32",
            "params": [{
                "name": "idAllotment",
                "type": "Edm.Int32"
            }, {
                "name": "Date",
                "type": "Edm.DateTimeOffset"
            }]
        },
        GetGroupReservations: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "GroupId",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuoteItem"
        },
        GetGroupPaxs: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "GroupId",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem"
        },
        Anonymitation: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.Boolean",
            "params": [{
                "name": "ClientId",
                "type": "Edm.Int32"
            }, {
                "name": "RemovePhisically",
                "type": "Edm.Boolean"
            }]
        },
        GetToken: {
            "type": "$data.ServiceFunction",
            "returnType": "Edm.String",
            "params": [{
                "name": "key",
                "type": "Edm.Int32"
            }]
        },
        GetTaxonomiesForProduct: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "ProductTypes",
                "type": "Array",
                "elementType": "Edm.Int32"
            }, {
                "name": "ProductCategoryId",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.General.Domain.Services.TaxonomicField"
        },
        ExchangeRate: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "FromCurrencyId",
                "type": "Edm.Int32"
            }, {
                "name": "ToCurrencyId",
                "type": "Edm.Int32"
            }, {
                "name": "Amount",
                "type": "Edm.Double"
            }, {
                "name": "BookingDate",
                "type": "Edm.DateTimeOffset"
            }, {
                "name": "ServiceDate",
                "type": "Edm.DateTimeOffset"
            }, {
                "name": "Mode",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.Plugins.Core.Services.ExchangeRateResult"
        },
        AvailabilityAllotment: {
            "type": "$data.ServiceFunction",
            "returnType": "$data.Queryable",
            "params": [{
                "name": "idAllotment",
                "type": "Edm.Int32"
            }, {
                "name": "year",
                "type": "Edm.Int32"
            }],
            "elementType": "BookemZulu.Products.Domain.Services.AvailabilityAllotmentItem"
        }
    });

    exports.BookemZulu = {
        "Accounting": {
            "Logic": {
                "ViewModels": {
                    "InvoiceSummary": types["BookemZulu.Accounting.Logic.ViewModels.InvoiceSummary"],
                    "InvoiceEntrySummary": types["BookemZulu.Accounting.Logic.ViewModels.InvoiceEntrySummary"],
                    "PaymentSummary": types["BookemZulu.Accounting.Logic.ViewModels.PaymentSummary"]
                }
            },
            "Domain": {
                "Models": {
                    "AccountingTarget": types["BookemZulu.Accounting.Domain.Models.AccountingTarget"],
                    "InvoiceType": types["BookemZulu.Accounting.Domain.Models.InvoiceType"],
                    "InvoiceStatus": types["BookemZulu.Accounting.Domain.Models.InvoiceStatus"]
                }
            }
        },
        "Bookings": {
            "Logic": {
                "ViewModels": {
                    "BreakdownEntry": types["BookemZulu.Bookings.Logic.ViewModels.BreakdownEntry"],
                    "AgentSummary": types["BookemZulu.Bookings.Logic.ViewModels.AgentSummary"],
                    "AgentItem": types["BookemZulu.Bookings.Logic.ViewModels.AgentItem"],
                    "AgentBrandItem": types["BookemZulu.Bookings.Logic.ViewModels.AgentBrandItem"],
                    "AgentPolicyItem": types["BookemZulu.Bookings.Logic.ViewModels.AgentPolicyItem"],
                    "AgentMarketItem": types["BookemZulu.Bookings.Logic.ViewModels.AgentMarketItem"],
                    "PolicySummary": types["BookemZulu.Bookings.Logic.ViewModels.PolicySummary"],
                    "PolicyItem": types["BookemZulu.Bookings.Logic.ViewModels.PolicyItem"],
                    "QuotePolicySummary": types["BookemZulu.Bookings.Logic.ViewModels.QuotePolicySummary"],
                    "QuotePolicyItem": types["BookemZulu.Bookings.Logic.ViewModels.QuotePolicyItem"],
                    "SellMarginPolicySummary": types["BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicySummary"],
                    "SellMarginPolicyItem": types["BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicyItem"],
                    "QuoteProductVisibilityPolicySummary": types["BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicySummary"],
                    "QuoteProductVisibilityPolicyItem": types["BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem"],
                    "PolicyRuleItem": types["BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem"],
                    "QuoteSummary": types["BookemZulu.Bookings.Logic.ViewModels.QuoteSummary"],
                    "QuoteItem": types["BookemZulu.Bookings.Logic.ViewModels.QuoteItem"],
                    "QuotePaxItem": types["BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem"],
                    "QuoteEntrySummary": types["BookemZulu.Bookings.Logic.ViewModels.QuoteEntrySummary"],
                    "QuoteEntryItem": types["BookemZulu.Bookings.Logic.ViewModels.QuoteEntryItem"],
                    "QuoteItineraryGroupSummary": types["BookemZulu.Bookings.Logic.ViewModels.QuoteItineraryGroupSummary"]
                }
            },
            "Domain": {
                "Models": {
                    "QuoteEntryStatus": types["BookemZulu.Bookings.Domain.Models.QuoteEntryStatus"],
                    "QuotePolicyType": types["BookemZulu.Bookings.Domain.Models.QuotePolicyType"],
                    "QuoteStatus": types["BookemZulu.Bookings.Domain.Models.QuoteStatus"],
                    "QuotePaymentMode": types["BookemZulu.Bookings.Domain.Models.QuotePaymentMode"],
                    "EntityMappingType": types["BookemZulu.Bookings.Domain.Models.EntityMappingType"]
                }
            }
        },
        "Crm": {
            "Logic": {
                "ViewModels": {
                    "ClientItem": types["BookemZulu.Crm.Logic.ViewModels.ClientItem"],
                    "ClientSummary": types["BookemZulu.Crm.Logic.ViewModels.ClientSummary"]
                },
                "JsonModels": {
                    "ContactItem": types["BookemZulu.Crm.Logic.JsonModels.ContactItem"],
                    "PhoneItem": types["BookemZulu.Crm.Logic.JsonModels.PhoneItem"],
                    "EmailItem": types["BookemZulu.Crm.Logic.JsonModels.EmailItem"]
                }
            },
            "Domain": {
                "Models": {
                    "ClientPriority": types["BookemZulu.Crm.Domain.Models.ClientPriority"],
                    "ClientType": types["BookemZulu.Crm.Domain.Models.ClientType"],
                    "ClientStatus": types["BookemZulu.Crm.Domain.Models.ClientStatus"]
                }
            }
        },
        "GDPR": {
            "Logic": {
                "ViewModels": {
                    "ClientGDPRSummary": types["BookemZulu.GDPR.Logic.ViewModels.ClientGDPRSummary"],
                    "ClientGDPRItem": types["BookemZulu.GDPR.Logic.ViewModels.ClientGDPRItem"],
                    "QuoteGDPRItem": types["BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem"],
                    "QuotePaxGDPRItem": types["BookemZulu.GDPR.Logic.ViewModels.QuotePaxGDPRItem"]
                }
            }
        },
        "Core": {
            "Logic": {
                "ViewModels": {
                    "Security": {
                        "UserSummary": types["BookemZulu.Core.Logic.ViewModels.Security.UserSummary"],
                        "UserItem": types["BookemZulu.Core.Logic.ViewModels.Security.UserItem"],
                        "RoleSummary": types["BookemZulu.Core.Logic.ViewModels.Security.RoleSummary"],
                        "RoleItem": types["BookemZulu.Core.Logic.ViewModels.Security.RoleItem"],
                        "UserRoleSummary": types["BookemZulu.Core.Logic.ViewModels.Security.UserRoleSummary"],
                        "PermissionItem": types["BookemZulu.Core.Logic.ViewModels.Security.PermissionItem"]
                    },
                    "LanguageSummary": types["BookemZulu.Core.Logic.ViewModels.LanguageSummary"],
                    "LanguageItem": types["BookemZulu.Core.Logic.ViewModels.LanguageItem"],
                    "AutocompleteSummary": types["BookemZulu.Core.Logic.ViewModels.AutocompleteSummary"],
                    "EntitySchemaItem": types["BookemZulu.Core.Logic.ViewModels.EntitySchemaItem"],
                    "ConfigOptionItem": types["BookemZulu.Core.Logic.ViewModels.ConfigOptionItem"]
                }
            },
            "Domain": {
                "Models": {
                    "EntitySchemaType": types["BookemZulu.Core.Domain.Models.EntitySchemaType"],
                    "DocumentTemplateCategoryType": types["BookemZulu.Core.Domain.Models.DocumentTemplateCategoryType"],
                    "User": types["BookemZulu.Core.Domain.Models.User"],
                    "UserRole": types["BookemZulu.Core.Domain.Models.UserRole"]
                }
            },
            "Models": {
                "ProductType": types["BookemZulu.Core.Models.ProductType"]
            }
        },
        "General": {
            "Logic": {
                "ViewModels": {
                    "RegionItem": types["BookemZulu.General.Logic.ViewModels.RegionItem"],
                    "RegionSummary": types["BookemZulu.General.Logic.ViewModels.RegionSummary"],
                    "PlaceSummary": types["BookemZulu.General.Logic.ViewModels.PlaceSummary"],
                    "PlaceItem": types["BookemZulu.General.Logic.ViewModels.PlaceItem"],
                    "AirportItem": types["BookemZulu.General.Logic.ViewModels.AirportItem"],
                    "AirlineSummary": types["BookemZulu.General.Logic.ViewModels.AirlineSummary"],
                    "TaxSummary": types["BookemZulu.General.Logic.ViewModels.TaxSummary"],
                    "TaxItem": types["BookemZulu.General.Logic.ViewModels.TaxItem"],
                    "AirlineItem": types["BookemZulu.General.Logic.ViewModels.AirlineItem"],
                    "MarketSummary": types["BookemZulu.General.Logic.ViewModels.MarketSummary"],
                    "MarketItem": types["BookemZulu.General.Logic.ViewModels.MarketItem"],
                    "CurrencySummary": types["BookemZulu.General.Logic.ViewModels.CurrencySummary"],
                    "CurrencyItem": types["BookemZulu.General.Logic.ViewModels.CurrencyItem"],
                    "BrandSummary": types["BookemZulu.General.Logic.ViewModels.BrandSummary"],
                    "BrandItem": types["BookemZulu.General.Logic.ViewModels.BrandItem"],
                    "DocumentTemplateCategorySummary": types["BookemZulu.General.Logic.ViewModels.DocumentTemplateCategorySummary"],
                    "DocumentTemplateCategoryItem": types["BookemZulu.General.Logic.ViewModels.DocumentTemplateCategoryItem"],
                    "DocumentTemplateSummary": types["BookemZulu.General.Logic.ViewModels.DocumentTemplateSummary"],
                    "DocumentTemplateItem": types["BookemZulu.General.Logic.ViewModels.DocumentTemplateItem"],
                    "DocumentTemplateBrandItem": types["BookemZulu.General.Logic.ViewModels.DocumentTemplateBrandItem"],
                    "DocumentTemplateMarketItem": types["BookemZulu.General.Logic.ViewModels.DocumentTemplateMarketItem"],
                    "CustomDocumentTemplateSummary": types["BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateSummary"],
                    "CustomDocumentTemplateItem": types["BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateItem"],
                    "EmailDocumentTemplateSummary": types["BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateSummary"],
                    "EmailDocumentTemplateItem": types["BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateItem"],
                    "FileSystemSummary": types["BookemZulu.General.Logic.ViewModels.FileSystemSummary"],
                    "TaxonomyItem": types["BookemZulu.General.Logic.ViewModels.TaxonomyItem"],
                    "TaxonomySummary": types["BookemZulu.General.Logic.ViewModels.TaxonomySummary"],
                    "ApiKeyItem": types["BookemZulu.General.Logic.ViewModels.ApiKeyItem"]
                }
            },
            "Domain": {
                "Services": {
                    "TaxonomicField": types["BookemZulu.General.Domain.Services.TaxonomicField"]
                },
                "Models": {
                    "MarketPriceType": types["BookemZulu.General.Domain.Models.MarketPriceType"],
                    "PlaceType": types["BookemZulu.General.Domain.Models.PlaceType"],
                    "MarketMarginType": types["BookemZulu.General.Domain.Models.MarketMarginType"],
                    "EmailDocumentTarget": types["BookemZulu.General.Domain.Models.EmailDocumentTarget"],
                    "Tax": types["BookemZulu.General.Domain.Models.Tax"]
                }
            }
        },
        "Products": {
            "Logic": {
                "ViewModels": {
                    "ProductProviderItem": types["BookemZulu.Products.Logic.ViewModels.ProductProviderItem"],
                    "EntityMappingItem": types["BookemZulu.Products.Logic.ViewModels.EntityMappingItem"],
                    "SupplierSummary": types["BookemZulu.Products.Logic.ViewModels.SupplierSummary"],
                    "SupplierItem": types["BookemZulu.Products.Logic.ViewModels.SupplierItem"],
                    "TransportCompanyOfficeItem": types["BookemZulu.Products.Logic.ViewModels.TransportCompanyOfficeItem"],
                    "ProductCategorySummary": types["BookemZulu.Products.Logic.ViewModels.ProductCategorySummary"],
                    "ProductCategoryItem": types["BookemZulu.Products.Logic.ViewModels.ProductCategoryItem"],
                    "ProductServiceTypeItem": types["BookemZulu.Products.Logic.ViewModels.ProductServiceTypeItem"],
                    "ProductServiceTypeSummary": types["BookemZulu.Products.Logic.ViewModels.ProductServiceTypeSummary"],
                    "ProductSummary": types["BookemZulu.Products.Logic.ViewModels.ProductSummary"],
                    "ProductItem": types["BookemZulu.Products.Logic.ViewModels.ProductItem"],
                    "TourItineraryItem": types["BookemZulu.Products.Logic.ViewModels.TourItineraryItem"],
                    "TourItineraryProductItem": types["BookemZulu.Products.Logic.ViewModels.TourItineraryProductItem"],
                    "TourItineraryDateItem": types["BookemZulu.Products.Logic.ViewModels.TourItineraryDateItem"],
                    "ContractSummary": types["BookemZulu.Products.Logic.ViewModels.ContractSummary"],
                    "ContractItem": types["BookemZulu.Products.Logic.ViewModels.ContractItem"],
                    "ContractMarketItem": types["BookemZulu.Products.Logic.ViewModels.ContractMarketItem"],
                    "ContractRangeDateItem": types["BookemZulu.Products.Logic.ViewModels.ContractRangeDateItem"],
                    "ContractServiceTypeItem": types["BookemZulu.Products.Logic.ViewModels.ContractServiceTypeItem"],
                    "CurrencyDefaultRateItem": types["BookemZulu.Products.Logic.ViewModels.CurrencyDefaultRateItem"],
                    "CurrencyExchangeRateItem": types["BookemZulu.Products.Logic.ViewModels.CurrencyExchangeRateItem"],
                    "AllotmentSummary": types["BookemZulu.Products.Logic.ViewModels.AllotmentSummary"],
                    "AllotmentItem": types["BookemZulu.Products.Logic.ViewModels.AllotmentItem"],
                    "AllotmentRangeSummary": types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeSummary"],
                    "AllotmentRangeItem": types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem"],
                    "AllotmentRangeDailyItem": types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeDailyItem"]
                }
            },
            "Domain": {
                "Services": {
                    "AvailabilityAllotmentItem": types["BookemZulu.Products.Domain.Services.AvailabilityAllotmentItem"]
                },
                "Models": {
                    "SupplierType": types["BookemZulu.Products.Domain.Models.SupplierType"],
                    "CurrencyExchangeType": types["BookemZulu.Products.Domain.Models.CurrencyExchangeType"],
                    "AllotmentRangeType": types["BookemZulu.Products.Domain.Models.AllotmentRangeType"]
                }
            }
        },
        "Plugins": {
            "Core": {
                "Services": {
                    "ExchangeRateResult": types["BookemZulu.Plugins.Core.Services.ExchangeRateResult"]
                },
                "Models": {
                    "Payments": {
                        "PaymentMethod": types["BookemZulu.Plugins.Core.Models.Payments.PaymentMethod"],
                        "PaymentType": types["BookemZulu.Plugins.Core.Models.Payments.PaymentType"],
                        "PaymentStatus": types["BookemZulu.Plugins.Core.Models.Payments.PaymentStatus"]
                    }
                }
            }
        },
        "Rules": {
            "Logic": {
                "ViewModels": {
                    "RuleItem": types["BookemZulu.Rules.Logic.ViewModels.RuleItem"],
                    "RuleSummary": types["BookemZulu.Rules.Logic.ViewModels.RuleSummary"],
                    "UserTaskItem": types["BookemZulu.Rules.Logic.ViewModels.UserTaskItem"],
                    "UserTaskSummary": types["BookemZulu.Rules.Logic.ViewModels.UserTaskSummary"]
                }
            },
            "Domain": {
                "Models": {
                    "Rules": {
                        "RuleExecutionMode": types["BookemZulu.Rules.Domain.Models.Rules.RuleExecutionMode"]
                    },
                    "UserTasks": {
                        "TaskState": types["BookemZulu.Rules.Domain.Models.UserTasks.TaskState"]
                    }
                }
            }
        },
        "OpenTypes": {
            "Product": types["BookemZulu.OpenTypes.Product"],
            "ExtraProperties": types["BookemZulu.OpenTypes.ExtraProperties"],
            "Parent": types["BookemZulu.OpenTypes.Parent"],
            "Service": types["BookemZulu.OpenTypes.Service"],
            "CostPriceResult": types["BookemZulu.OpenTypes.CostPriceResult"],
            "SellPriceResult": types["BookemZulu.OpenTypes.SellPriceResult"],
            "Breakdown": types["BookemZulu.OpenTypes.Breakdown"],
            "History": types["BookemZulu.OpenTypes.History"],
            "CostCommission": types["BookemZulu.OpenTypes.CostCommission"],
            "SellCommission": types["BookemZulu.OpenTypes.SellCommission"],
            "Drivers": types["BookemZulu.OpenTypes.Drivers"],
            "Features": types["BookemZulu.OpenTypes.Features"],
            "ErratasConfirmed": types["BookemZulu.OpenTypes.ErratasConfirmed"],
            "AllotmentAvailable": types["BookemZulu.OpenTypes.AllotmentAvailable"],
            "Occupancy": types["BookemZulu.OpenTypes.Occupancy"],
            "IsPackage": types["BookemZulu.OpenTypes.IsPackage"],
            "Itinerary": types["BookemZulu.OpenTypes.Itinerary"],
            "DepartureAirport": types["BookemZulu.OpenTypes.DepartureAirport"],
            "DestinationAirport": types["BookemZulu.OpenTypes.DestinationAirport"],
            "Category": types["BookemZulu.OpenTypes.Category"],
            "Segments": types["BookemZulu.OpenTypes.Segments"],
            "Stops": types["BookemZulu.OpenTypes.Stops"],
            "FlightLegs": types["BookemZulu.OpenTypes.FlightLegs"],
            "ExternalIds": types["BookemZulu.OpenTypes.ExternalIds"],
            "ClientExternalIds": types["BookemZulu.OpenTypes.ClientExternalIds"],
            "IsATOL": types["BookemZulu.OpenTypes.IsATOL"],
            "Person": types["BookemZulu.OpenTypes.Person"],
            "Company": types["BookemZulu.OpenTypes.Company"],
            "Phones": types["BookemZulu.OpenTypes.Phones"],
            "Emails": types["BookemZulu.OpenTypes.Emails"],
            "Contact": types["BookemZulu.OpenTypes.Contact"],
            "Note": types["BookemZulu.OpenTypes.Note"],
            "Children": types["BookemZulu.OpenTypes.Children"],
            "DisplayName": types["BookemZulu.OpenTypes.DisplayName"],
            "Translations": types["BookemZulu.OpenTypes.Translations"],
            "Datasets": types["BookemZulu.OpenTypes.Datasets"],
            "TaxonomyTags": types["BookemZulu.OpenTypes.TaxonomyTags"],
            "Html": types["BookemZulu.OpenTypes.Html"],
            "Subject": types["BookemZulu.OpenTypes.Subject"],
            "ReceiveTaskNotifications": types["BookemZulu.OpenTypes.ReceiveTaskNotifications"],
            "AgeBands": types["BookemZulu.OpenTypes.AgeBands"],
            "CustomOccupancyConfigs": types["BookemZulu.OpenTypes.CustomOccupancyConfigs"],
            "Cost": types["BookemZulu.OpenTypes.Cost"],
            "Price": types["BookemZulu.OpenTypes.Price"],
            "Structure": types["BookemZulu.OpenTypes.Structure"],
            "Accomodation": types["BookemZulu.OpenTypes.Accomodation"],
            "Transfer": types["BookemZulu.OpenTypes.Transfer"],
            "Flight": types["BookemZulu.OpenTypes.Flight"],
            "Elements": types["BookemZulu.OpenTypes.Elements"],
            "Content": types["BookemZulu.OpenTypes.Content"],
            "OpeningHour": types["BookemZulu.OpenTypes.OpeningHour"],
            "ClosingHour": types["BookemZulu.OpenTypes.ClosingHour"],
            "CanDropoff": types["BookemZulu.OpenTypes.CanDropoff"],
            "Observations": types["BookemZulu.OpenTypes.Observations"],
            "OtherPaxsConfig": types["BookemZulu.OpenTypes.OtherPaxsConfig"],
            "Erratas": types["BookemZulu.OpenTypes.Erratas"],
            "Visibility": types["BookemZulu.OpenTypes.Visibility"],
            "PaxConfig": types["BookemZulu.OpenTypes.PaxConfig"],
            "Occupancies": types["BookemZulu.OpenTypes.Occupancies"],
            "MarketsPrice": types["BookemZulu.OpenTypes.MarketsPrice"],
            "Products": types["BookemZulu.OpenTypes.Products"],
            "OccupanciesPrice": types["BookemZulu.OpenTypes.OccupanciesPrice"],
            "ConditionValues": types["BookemZulu.OpenTypes.ConditionValues"],
            "Conditions": types["BookemZulu.OpenTypes.Conditions"],
            "BranchExecutors": types["BookemZulu.OpenTypes.BranchExecutors"],
            "AlternativeExecutors": types["BookemZulu.OpenTypes.AlternativeExecutors"],
            "Policy": types["BookemZulu.OpenTypes.Policy"],
            "Name": types["BookemZulu.OpenTypes.Name"],
            "ConditionDefinitionType": types["BookemZulu.OpenTypes.ConditionDefinitionType"],
            "LastState": types["BookemZulu.OpenTypes.LastState"],
            "LastExecutionMessage": types["BookemZulu.OpenTypes.LastExecutionMessage"],
            "RetryCount": types["BookemZulu.OpenTypes.RetryCount"],
            "MaxRetryInterval": types["BookemZulu.OpenTypes.MaxRetryInterval"],
            "MinRetryInterval": types["BookemZulu.OpenTypes.MinRetryInterval"],
            "HistoryLogs": types["BookemZulu.OpenTypes.HistoryLogs"],
            "Logs": types["BookemZulu.OpenTypes.Logs"],
            "Changes": types["BookemZulu.OpenTypes.Changes"],
            "ChangeReason": types["BookemZulu.OpenTypes.ChangeReason"],
            "UserTaskModifiedBy": types["BookemZulu.OpenTypes.UserTaskModifiedBy"]
        }
    };

    exports.OData = {
        "Container": types["OData.Container"]
    };

    var ctxType = exports.type;
    exports.factory = function(config) {
        if (ctxType) {
            var cfg = $data.typeSystem.extend({
                name: "oData",
                oDataServiceHost: "http://localhost:20300/odata",
                withCredentials: false,
                maxDataServiceVersion: "4.0"
            }, config);
            return new ctxType(cfg);
        } else {
            return null;
        }
    };

    if (typeof Reflect !== "undefined" && typeof Reflect.defineMetadata === "function") {
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.AgentItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.AgentBrandItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.AgentPolicyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.AgentMarketItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.PolicyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.QuotePolicyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.SellMarginPolicyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.QuoteProductVisibilityPolicyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.PolicyRuleItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.QuoteItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.QuotePaxItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Bookings.Logic.ViewModels.QuoteEntryItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Crm.Logic.ViewModels.ClientItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.GDPR.Logic.ViewModels.ClientGDPRItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.GDPR.Logic.ViewModels.QuoteGDPRItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.GDPR.Logic.ViewModels.QuotePaxGDPRItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.RegionItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.PlaceItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.TaxItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Core.Logic.ViewModels.EntitySchemaItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.AirlineItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.MarketItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.CurrencyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.BrandItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.DocumentTemplateCategoryItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.DocumentTemplateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.DocumentTemplateBrandItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.DocumentTemplateMarketItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.CustomDocumentTemplateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.EmailDocumentTemplateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.TaxonomyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.General.Logic.ViewModels.ApiKeyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ProductProviderItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.EntityMappingItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.SupplierItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.TransportCompanyOfficeItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ProductCategoryItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ProductServiceTypeItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ProductItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.TourItineraryItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.TourItineraryProductItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.TourItineraryDateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ContractItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ContractMarketItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ContractRangeDateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.ContractServiceTypeItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.CurrencyDefaultRateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.CurrencyExchangeRateItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.AllotmentItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Products.Logic.ViewModels.AllotmentRangeDailyItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Rules.Logic.ViewModels.RuleItem"].prototype)
        Reflect.defineMetadata("Org.OData.Core.V1.OptimisticConcurrency", ["timestamp"], types["BookemZulu.Rules.Logic.ViewModels.UserTaskItem"].prototype)
    }

});



//////////////////
// WEBPACK FOOTER
// ./src/core/services/data/JayDataContext.js
// module id = 16
// module chunks = 8